export default "__VITE_ASSET__BWWtDp4H__"